import React, { createContext, useEffect, useState } from "react";

//Redux
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

//Components
import AlertBox from "../../../../app/common-components/Alert";
import ButtonComponent from "../../../../app/common-components/ButtonComponent";
import CustomModal from "../../../../app/common-components/CustomModal";
import DrillDownOffCanvas from "../../../../app/common-components/DrillDown/DrillDownOffCanvas";
import Spinners from "../../../../app/common-components/Spinner";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData";
import { setIsOffCanvasOpen } from "../../../../app/commonSlice";
import ProjectCustomDrillDown from "./ProjectCustomDrillDown";
import ProjectDeleteModal from "./ProjectDeleteModel";

//Slice
import { effciencyApi } from "../../../../app/services/efficiencyApi";
import { projectList } from "./appConfigSlice";

// 3rdPraty Libraries
import { get } from "lodash";
import { FaInfoCircle } from "react-icons/fa";
import { FiEdit, FiTrash2 } from "react-icons/fi";

import DetailTable from "../../../../app/common-components/DetailTable/Index";
import { convertEpochToDate } from "../../../../app/utilities/helpers";

// Styles
import "../styles.scss";

export const ProjectContext = createContext();

const Projects = (props) => {
  console.log("yess");
  const dispatch = useDispatch();
  const { userName } = useSelector((state) => state.common.loggedUser);

  const { efficiency } = useSelector((state) => state);
  const {
    projectListData,
    projectListLoading,
  } = useSelector((state) => state.appConfig);
  const [pageNo, setpageNo] = useState(0);
  const [pageLimit, setpageLimit] = useState(10);
  const [searchKey, setsearchKey] = useState("");
  const calculatedPageCount = projectListData?.totalCount
    ? Math.ceil(projectListData?.totalCount / pageLimit)
    : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;

  const projectTableData = get(efficiency, "appConfig.projectTableData", []);
  const [loading, setLoading] = useState(true);
  const [projectState, setProjectState] = useState({
    limit: 10,
    page: 0,
    count: 0,
    totalPages: 1,
    importModal: false,
    newApplication: false,
    projectId: "",
    file: "",
    fileInfo: "",
    deleteModalOpen: false,
    loadPage: false,
    alert: false,
    alertType: "",
    alertMessage: "",
    fileError: "",
    loading: false,
    InfoBody: false,
    detailData: [],
  });

  const { state } = useLocation();
  const navigate = useNavigate();
  const applicationName = state?.appName;

  const [importProject] = effciencyApi.useImportProjectMutation();
  const payload = {
    keyword: searchKey,
  };

  const modalBodyInfo = () => {
    const data = projectState.detailData.original;
    const detailsTableData = [
      { header: "Added By", values: data?.createdBy ? data.createdBy : "-" },
      {
        header: "Added On",
        values: data?.createdDate ? convertEpochToDate(data.createdDate) : "-",
      },
      { header: "Updated By", values: data?.updatedBy ? data.updatedBy : "-" },
      {
        header: "Updated On",
        values: data?.updateDate ? convertEpochToDate(data.updateDate) : "-",
      },
    ];
    return (
      <>
        <h4 className="schedule-tool">{"Details"}</h4>
        <div>
          <DetailTable data={detailsTableData} />
        </div>
      </>
    );
  };
  const InfomodalCancelAccount = () => {
    setProjectState({
      ...projectState,
      InfoBody: false,
      detailData: [],
    });
  };

  const columns = [
    {
      Header: "Type",
      accessor: "type",
      disableSortBy: true,
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Tool Name",
      accessor: "tool",
      disableSortBy: true,
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Project Name",
      accessor: "projectName",
      disableSortBy: true,
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Details",
      className: "text-center noSort",
      disableSortBy: true,
      tdClassName: "text-center",
      thClassName: "text-center",
      Cell: ({ row }) => {
        return (
          <a
            title="Details"
            onClick={() => {
              setProjectState({
                ...projectState,
                InfoBody: true,
                detailData: row,
              });
            }}
          >
            <FaInfoCircle
              className="faInfoCircleStyle"
              size={15}
              data-bs-toggle="tooltip"
              data-bs-placement="left"
            />
          </a>
        );
      },
    },
    {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      Cell: ({ row }) => (
        <div className="Servercorrection  d-flex justify-content-center cloudAccountsAction">
          {" "}
          <div
            className="actcol p-0"
            style={{ display: "inline-block", margin: "0px 15px" }}
          >
            <FiEdit
              title="Edit"
              className="iconStyleActions"
              onClick={() => onEditData(row.original)}
            />
          </div>
          <div className="actcol p-0" style={{ width: "0%" }}>
            <FiTrash2
              title="Delete"
              className="iconStyleActions"
              onClick={() => onDeleteData(row.original)}
            />
          </div>
        </div>
      ),
    },
  ];
  const hideAlert = () => {
    setTimeout(() => {
      setProjectState((state) => ({
        ...state,
        alert: false,
        alertType: "",
        alertMessage: "",
      }));
    }, 2000);
  };
  useEffect(() => {
    projectState.alert && hideAlert();
  }, [projectState.alert]);

  const getProjectInfo = () => {
    dispatch(
      projectList({
        id: state.id,
        pageNumber: pageNo,
        itemsPerPage: pageLimit,
        payload,
      })
    );
  };
  useEffect(() => {
    if (state === null) {
      navigate("/configuration/cmdb");
      return;
    }
    getProjectInfo();
  }, [pageNo, pageLimit, searchKey]);

  const openDrillDown = async ({ title }, selectedLabels) => {
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        title: title,
        selectedData: {
          customDrillDownCanvas() {
            return (
              <ProjectCustomDrillDown
                title={title}
                rowId={state.id}
                projectType={selectedLabels ? selectedLabels.selectedType : ""}
                projectName={
                  selectedLabels?.projectName ? selectedLabels.projectName : ""
                }
                tablerecall={getProjectInfo}
              />
            );
          },
          selected: selectedLabels ? selectedLabels : "",
        },
      })
    );
  };
  const onEditData = async (data) => {
    const { tool: selectedTool, type: selectedType, projectName, id } = data;
    openDrillDown(
      { title: "Update Project" },
      { selectedTool, selectedType, projectName, id }
    );
  };
  const onDeleteData = (data) => {
    setProjectState((state) => ({
      ...state,
      projectId: data.id,
      deleteModalOpen: true,
    }));
  };

  const handleShow = () => {
    setProjectState((state) => ({
      ...state,
      importModal: true,
    }));
  };

  const handleClose = () =>
    setProjectState((state) => ({
      ...state,
      importModal: false,
      file: "",
      fileInfo: "",
    }));

  const postImportProject = () => {
    if (projectState.file === "") {
      setProjectState({
        ...projectState,
        fileError: "*Please choose the File",
        importModal: true,
      });
      return "";
    }
    const formData = new FormData();
    formData.append("file", projectState.file);
    importProject({ id: state.id, payload: formData, userName })
      .then((data) => {
        if (data.error && data.error.data === "Please upload a csv file!") {
          setProjectState((state) => ({
            ...state,
            importModal: false,
            alert: true,
            loadPage: !projectState.loadPage,
            file: "",
            fileInfo: "",
            fileError: "",
            alertType: "error",
            alertMessage: "Please upload a csv file!",
          }));
        } else {
          setProjectState((state) => ({
            ...state,
            importModal: false,
            alert: true,
            loadPage: !projectState.loadPage,
            file: "",
            fileInfo: "",
            fileError: "",
            alertType: "success",
            alertMessage: () => (
              <>
                <span>Import project completed successfully.</span>
                <a
                  onClick={DownloadStatusfile}
                  style={{ textDecoration: "underline", color: "#f6a821" }}
                >
                  Download: Status
                </a>
              </>
            ),
          }));
        }
      })
      .catch((error) => console.log(error));
  };

  function exportProjects() {
    fetch(`/export/project?cmdbId=${state.id}`).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "Code8_Project.csv";
        a.click();
      });
    });
  }

  const downlaodSample = () => {
    fetch("/template/project").then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "Project_Template.csv";
        a.click();
      });
    });
  };
  const DownloadStatusfile = () => {
    fetch("/downloadPDF?fileName=importAppConfigStatus").then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "Status.pdf";
        a.click();
      });
    });
  };
  const modalBody = () => (
    <div className="modal-body">
      <h4>Import Project</h4>
      <div className="errors">{projectState.fileError}</div>
      <p></p>
      <form id="upload-file-form" className="hide-ele">
        <div className="col-lg-12 upload-file-model">
          <label className="btn btn-submit chaos-btn ml-0 upload_btn">
            <input
              id="upload-file-input"
              data-testid="upload-file-input"
              accept=".csv"
              type="file"
              name="file"
              className="hide-ele"
              onChange={(event) => {
                setProjectState({
                  ...projectState,
                  file: event.target.files[0],
                  fileInfo: event.target.files[0].name,
                  fileError: "",
                });
              }}
            />
          </label>
          <span
            className="label label-default hide filepath"
            id="upload-file-info"
          >
            {projectState.fileInfo !== ""
              ? "C:\\fakepath\\" + `${projectState.fileInfo}`
              : ""}
          </span>
          <div className="col-md-12 upload_example">
            <a onClick={downlaodSample}>Project_Template.csv</a>
          </div>
        </div>
      </form>
      <div className="btnswrap">
        <ButtonComponent
          text="Cancel"
          className="cancelBtnStyle"
          onClick={() => {
            handleClose();
          }}
        />
        <ButtonComponent text="Submit" onClick={() => postImportProject()} />
      </div>
    </div>
  );
  const clickbtn = () => {
    return () => {
      openDrillDown({ title: "Map New Project" });
    };
  };

  const additionalBtnData = [
    {
      text: "Map New",
      btnComponent: (
        <>
          <button onClick={clickbtn()} className="solid-btn">
            Map New
          </button>
        </>
      ),
    },
  ];

  function getLimit(limit) {
    setpageLimit(limit);
    setpageNo(0);
  }
  function getPage(pageNo) {
    setpageNo(pageNo);
  }
  function getSearchKey(key) {
    setpageNo(0);
    setpageLimit(10);
    setsearchKey(key);
  }

  return (
    <>
      <ProjectContext.Provider value={{ projectState, setProjectState }}>
        <AlertBox
          alert={projectState.alert}
          type={projectState.alertType}
          message={projectState.alertMessage}
        />
        <ProjectDeleteModal tablerecall={getProjectInfo} />
        <DrillDownOffCanvas
          currentDrilldown={"Projects"}
          customClass={"flowblock toolwrap custom_scroll"}
          subHeading={"Please enter your Project data."}
        />
      </ProjectContext.Provider>
      <div className="mt-3 config_cover">
        <div className="btnwrap d-flex justify-content-between m-0">
          <div className="d-flex justify-content-end">
            <CustomModal
              modalOpen={projectState.importModal}
              modalBody={modalBody}
            />
          </div>
        </div>
      </div>

      <div className="grid-table config_cover">
        {projectListLoading ? (
          <Spinners />
        ) : (
          <CompleteTableData
            data={projectListData?.data || []}
            columns={columns}
            onPageLimitChange={getLimit}
            onPageNoChange={getPage}
            onSearch={getSearchKey}
            curentPageNumber={pageNo}
            pageLimit={pageLimit}
            searchKey={searchKey}
            totalPageCount={finalPageCount}
            listCount={projectListData?.totalCount}
            additionalBtnData={additionalBtnData}
          />
        )}
      </div>
      <CustomModal
        modalOpen={projectState.InfoBody}
        modalBody={modalBodyInfo}
        modalHide={InfomodalCancelAccount}
        closeBtn={true}
        closeBtnFuc={InfomodalCancelAccount}
      />
    </>
  );
};

export default Projects;
